import React from "react";
import InputField from "../../../common_component/component/InputField";
import { calculateAgeString } from "./utils";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";

const DateAge = ({ value, onChange }) => {
  const dobHandler = (e) => {
    const selectedDate = new Date(e.target.value);
    const currentDate = new Date();

    // Calculate the age in years
    let ageYears = currentDate.getFullYear() - selectedDate.getFullYear();
    const monthDifference = currentDate.getMonth() - selectedDate.getMonth();

    // Adjust if the current month is earlier than the birth month
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && currentDate.getDate() < selectedDate.getDate())
    ) {
      ageYears--;
    }

    // Calculate months part if not exactly in the same month
    const months =
      monthDifference >= 0 ? monthDifference : 12 + monthDifference;

    // Convert years and months to the desired decimal format
    const age = ageYears + months / 12;

    // Update the state with the calculated age and the selected DOB
    if (age > 0) {
      onChange({ age: age.toFixed(1), dob: e.target.value });
    }
  };

  const sm = !useMediaQuery({ query: "(min-width:1024px)" });

  function decimalToMonths(decimal) {
    // Extract the integer part and the decimal part
    const integerPart = Math.floor(decimal);
    const decimalPart = decimal - integerPart;

    // //(decimalPart);

    // Convert the integer part to months (years * 12)
    const monthsFromIntegerPart = integerPart * 12;
    // //("INTEGER PART", integerPart);
    // For the decimal part, scale it to months with a specific conversion
    // For example, 0.22 should be converted to 2 months to fit with the 14 months total
    var monthsFromDecimalPart = Math.round(decimalPart * 10);
    // //("DECIMAL PART", monthsFromDecimalPart);
    // Total months = integer part (years in months) + months from decimal part
    const totalMonths = monthsFromIntegerPart + monthsFromDecimalPart;

    const decimalVal = decimalPart;
    // //("hyy", decimalVal);
    if (
      decimalVal >= 0.11 &&
      integerPart == 0 &&
      decimalVal != 0.1 &&
      decimalVal != 0.2 &&
      decimalVal != 0.3 &&
      decimalVal != 0.4 &&
      decimalVal != 0.5 &&
      decimalVal != 0.6 &&
      decimalVal != 0.7 &&
      decimalVal != 0.8 &&
      decimalVal != 0.9
    ) {
      const monthsFromDecimal = Math.round(decimalPart * 100);
      //("Hyyy", monthsFromDecimal);
      return monthsFromDecimal;
    }

    return totalMonths;
  }
  const ageHandler = (e) => {
    const patientAge = Number(e.target.value);
    //(decimalToMonths(patientAge));

    if (patientAge > 150) {
      toast.warning("Age must be less than 150 years old");
      return;
    }

    if (patientAge > 0) {
      const currentDate = new Date();
      const years = Math.floor(patientAge);
      const months = decimalToMonths(patientAge) - years * 12; // Calculate only the months part

      // Subtract years and months from the current date
      const birthdate = new Date(
        currentDate.getFullYear() - years,
        currentDate.getMonth() - months,
        1
      );

      // Ensure the birthdate is adjusted correctly when subtracting months causes month underflow
      if (birthdate.getMonth() > currentDate.getMonth()) {
        birthdate.setFullYear(birthdate.getFullYear() - 1);
      }

      const formattedBirthdate = `${birthdate.getFullYear()}-${String(
        birthdate.getMonth() + 1
      ).padStart(2, "0")}-01`;

      onChange({ age: e.target.value, dob: formattedBirthdate });
    } else {
      onChange({ age: "", dob: "" });
    }
  };

  // Synchronize when value updates
  React.useEffect(() => {
    if (value?.dob && !value?.age) {
      dobHandler({ target: { value: value.dob } });
    } else if (value?.age && !value?.dob) {
      ageHandler({ target: { value: value.age } });
    }
  }, [value]);

  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: "10px" }}>
      <div style={{ width: "48%" }}>
        <InputField
          label={"Age"}
          type={"number"}
          value={value?.age}
          onChange={ageHandler}
          min={0.1} // Minimum value for age
          max={150.0} // Maximum value for age
          step={0.1}

          // required
        />
      </div>
      <div
        className="lg:text-sm xl:text-base xlarge:text-xl"
        style={{ paddingBottom: "10px" }}
      >
        OR
      </div>

      <div style={{ width: "48%" }}>
        <InputField
          label={"DOB"}
          type={"date"}
          value={value?.dob}
          onChange={dobHandler}
          // required
        />
      </div>
    </div>
  );
};

export default DateAge;
